import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/** @jsx jsx */

import React, { useMemo } from 'react';
import { css, jsx } from '@emotion/react';
import AtlaskitAvatarGroup from '@atlaskit/avatar-group';
import { SmartLinkSize } from '../../../../../constants';
import { messages } from '../../../../../messages';
import { useIntl } from 'react-intl-next';
import { ElementName } from '../../../../../constants';
import { getFormattedMessageAsString } from '../../utils';
var MAX_COUNT = 4;
var getStyles = function getStyles(size) {
  var styles = css({
    display: 'inline-flex',
    ul: {
      marginRight: "var(--ds-space-100, 0.5rem)",
      marginTop: 0
    }
  });
  switch (size) {
    case SmartLinkSize.XLarge:
    case SmartLinkSize.Large:
      // Default AK small size
      return styles;
    case SmartLinkSize.Medium:
    case SmartLinkSize.Small:
    default:
      // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
      return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        ", "\n        li {\n          span,\n          svg {\n            max-height: 1.25rem;\n            max-width: 1.25rem;\n          }\n        }\n      "])), styles);
  }
};
var getPersonNameWithPrefix = function getPersonNameWithPrefix(elementName, personName, intl) {
  switch (elementName) {
    case ElementName.AssignedToGroup:
      return getFormattedMessageAsString(intl, messages.assigned_to, personName);
    case ElementName.OwnedByGroup:
      return getFormattedMessageAsString(intl, messages.owned_by, personName);
    case ElementName.AuthorGroup:
      return getFormattedMessageAsString(intl, messages.created_by, personName);
    default:
      return personName;
  }
};

/**
 * A base element that displays a group of avatars.
 * @internal
 * @param {AvatarGroupProps} AvatarGroupProps - The props necessary for the AvatarGroup.
 * @see AuthorGroup
 * @see CollaboratorGroup
 */
var AvatarGroup = function AvatarGroup(_ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$maxCount = _ref.maxCount,
    maxCount = _ref$maxCount === void 0 ? MAX_COUNT : _ref$maxCount,
    name = _ref.name,
    overrideCss = _ref.overrideCss,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? SmartLinkSize.Medium : _ref$size,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'smart-element-avatar-group' : _ref$testId,
    _ref$showNamePrefix = _ref.showNamePrefix,
    showNamePrefix = _ref$showNamePrefix === void 0 ? false : _ref$showNamePrefix,
    _ref$showFallbackAvat = _ref.showFallbackAvatar,
    showFallbackAvatar = _ref$showFallbackAvat === void 0 ? true : _ref$showFallbackAvat;
  var intl = useIntl();
  var data = useMemo(function () {
    if (!items.length && showFallbackAvatar) {
      switch (name) {
        case ElementName.AssignedToGroup:
          return [{
            name: getFormattedMessageAsString(intl, messages.unassigned)
          }];
        default:
          return [];
      }
    }

    //show a name prefix if there is one Avatar in a group only
    if (name && items.length === 1 && showNamePrefix) {
      return items.map(function (person) {
        return _objectSpread(_objectSpread({}, person), {}, {
          name: getPersonNameWithPrefix(name, person.name, intl) || person.name
        });
      });
    }
    return items;
  }, [name, items, showNamePrefix, showFallbackAvatar, intl]);
  if (!data.length) {
    return null;
  }
  return jsx("span", {
    css: [getStyles(size), overrideCss],
    "data-fit-to-content": true,
    "data-smart-element": name,
    "data-smart-element-avatar-group": true,
    "data-testid": testId
  }, jsx(AtlaskitAvatarGroup, {
    maxCount: maxCount,
    appearance: "stack",
    size: "small",
    data: data,
    testId: testId
  }));
};
export default AvatarGroup;